module.exports = __webpack_public_path__ + "img/img03.4f4f8d33.png";